export const formatPrice = (precio) => {
    return `$${precio.toLocaleString('es-AR')}`;
  };
  